// extracted by mini-css-extract-plugin
export default {"recos":"e3-z","productCardOverride":"f3-z","rowHasBadge":"g3-z"};